import can from 'can';
import {BaseMap} from '../../js/usga.base-map';
import {LeaderBoardBaseMap} from '../leaderboard-base/leaderboard-base-map';
import {LeaderBoardPlayers, LeaderBoardTeam} from '../leaderboard-contestant/leaderboard-contestant-model';

export const LeaderBoardMatch = LeaderBoardBaseMap.extend({

    define: {
        'number': {
            type: '*',
            value: null
        },
        status: {
            type: 'string',
            value: ''
        },
        players: {
            Type: LeaderBoardPlayers,
            Value: LeaderBoardPlayers
        },
        team: {
            Type: LeaderBoardTeam.List,
            Value: LeaderBoardTeam.List
        },
        courseData: {
            Type: BaseMap.List,
            Value: BaseMap.List
        }
    },
    idField: can.compute(function() {
        if (this.attr('idint')) {
            return 'match' + this.attr('idint');
        } else {
            return 'match' + this.attr('number');
        }
    }),
    getStatus: can.compute(function() {
		const status = this.attr('status');
		const standingData = this.attr('standing');
		const thru = this.parseStanding(standingData).status;
		if (status != 'completed' && status != 'notstarted') {
            return thru ? 'thru ' + thru : '';
        }
        return null;
    }),
    getStanding: can.compute(function() {
		const status = this.attr('status');
		const standingData = this.attr('standing');
		if (status == 'notstarted') {
            return this.attr('teetime');
        } else {
            return this.parseStanding(standingData).standing;
        }
    }),
    getMiniLbStanding: can.compute(function() {
		const status = this.attr('status');
		const standingData = this.attr('standing');
		if (status == 'notstarted') {
            return this.attr('standing');
        } else {
            return this.parseStanding(standingData).standing;
        }
    }),
    parseStanding: function(standingData) {
		const output = {
			standing: null,
			status: null
		};
		let standingParts = [];
		if (standingData) {
            standingParts = standingData.split(/thru/i);
            output.standing = standingParts[0];
            output.status = standingParts[1];
        }
        return output;
    },
    isCompleted: can.compute(function() {
        return this.attr('status') == 'completed';
    }),
    isInProgress: can.compute(function() {
        return this.attr('status') != 'completed' && this.attr('status') != 'notstarted';
    }),
    isStarted: can.compute(function() {
        return this.attr('status') != 'notstarted';
    })

});